import React from 'react';
import _ from 'lodash';
import { IonButton, IonButtons, IonContent, IonFab, IonFabButton, IonFabList, IonHeader, IonIcon,
    IonInfiniteScroll, IonInfiniteScrollContent, IonList, IonMenuButton, IonModal, IonPage,
    IonSearchbar, IonSelect, IonSelectOption, IonTitle, IonToolbar, IonLoading, IonItem, IonCheckbox, IonAlert, IonChip, IonLabel
} from '@ionic/react';
import {
    showLoading,
    updateTenant,
    deleteTenant,
    showFeatureComingSoon,
    fetchTenants,
    sendPaymentReminder,
    downloadTenantTransactionsReport,
    fetchOptions,
    downloadTenantsReport,
    sendTenantStatement,
    fetchCurrency
} from '../../redux/actions';
 import {
    Row,
    Col,
} from 'reactstrap';
import { fetchPropertiesUnitsTenants } from '../../redux/middleware';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import store from '../../redux/store';
import { add, cash, personOutline, receipt, optionsOutline } from 'ionicons/icons';
import TenantListItem from './TenantListItem';
import { OCCUPANT_TYPE, UNIFORM_RESOURCE_LOCATORS, colorTheme } from '../../utils/constants';
import { TenantForm } from '../Forms';
import PaymentForm from '../Forms/PaymentForm';
import TenantTransactions from '../Financials/TenantTransactions';
import { Mixpanel } from '../../redux/Mixpanel';
import InvoiceForm from '../Forms/InvoiceForm';
import IonCustomPropertySelect from '../../components/IonCustomPropertySelect';
import * as PermChecker from '../../utils/PermUtils';
import ShiftTenantForm from '../Forms/shiftTenant';
import SendMessageForm from '../Forms/sendMessageForm';
import NotificationPermissionModal from '../../components/NotificationPermissionModal';
import { openNotificationPromptIfEligible, handleNotificationPromptAllow, handleNotificationPromptDeny } from '../../utils/notificationPrompt';
import { handleChangeAmount } from '../../components/AmountFilter/amountFilterFunctions';
import AmountFilter from '../../components/AmountFilter/amountFilter';

const mapStateToProps = state => {
    return {
        properties: state.properties,
        units: state.units,
        tenants: state.tenants,
        tenantsOrder: state.tenantsOrder,
        options: state.options,
        payments: state.payments,
        invoices: state.invoices,
        currency: state.currency,
    };
}

const mapDispatchToProps = {
    showLoading,
    updateTenant,
    deleteTenant,
    showFeatureComingSoon,
    fetchTenants,
    sendPaymentReminder,
    downloadTenantTransactionsReport,
    fetchOptions,
    downloadTenantsReport,
    sendTenantStatement,
    fetchCurrency
};

const HOME_PAGE = "table";
const TENANT_FORM_PAGE = "tenantForm";
const MESSAGE_FORM_PAGE = "messageForm";
const TENANT_ACCOUNT = "tenantAccountTable";
const SHIFT_TENANT_FORM_PAGE = "shiftTenantForm";
const INVOICE_FORM_PAGE = "invoiceForm";
const PAYMENT_FORM_PAGE = "paymentForm";
const PAGE_FILTERS = "filters";
const PAGE_PROPERTY_RENT_INVOICE_FORM = "propertyRentInvoiceForm";
const PAGE_RECURRING_BILLS_INVOICE_FORM = "RecurringBillsInvoiceForm";

class Tenants extends React.Component{
    constructor(props){
        super(props);
        this.handleFilterModalDismiss = this.handleFilterModalDismiss.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleCloseTenantForm = this.handleCloseTenantForm.bind(this);
        this.handleClosePaymentForm = this.handleClosePaymentForm.bind(this);
        this.handleCloseInvoiceForm = this.handleCloseInvoiceForm.bind(this);
        this.handleChangeAmount = handleChangeAmount.bind(this);
        this.state = {
            showMenu: false,
            tab: HOME_PAGE,
            properties: [],
            unitId: "",
            propertyId: "",
            tenant: [],
            searchText: "",
            selectedTenants: [],
            tenantToShift: "",
            offset: "",
            archived: false,
            sortField: "unitName",
            sortOrder: "asc",
            daysToLeaseExpiry: 0,
            minBalance: 0,
            maxBalance: 0,
            userAllPerms: {},
            showLoading: false,
            isLoadingMore: false,
            showNotificationPrompt: false,
            lastAppliedNotificationFiltersSignature: "",
            filtersReady: false
        }
    }

    getNotificationFiltersSignature(notificationFilters) {
        if (!notificationFilters) return "";
        try {
            return JSON.stringify(notificationFilters);
        } catch (_error) {
            return "";
        }
    }

    getNotificationFiltersFromLocation() {
        return this.props.location?.state?.notificationFilters || null;
    }

    getUrlParams() {
        const searchParams = new URLSearchParams(this.props.location.search || "");
        return {
            propertyId: searchParams.get('propertyId') || '',
            minBalance: searchParams.get('minBalance') || '',
            maxBalance: searchParams.get('maxBalance') || '',
            archived: searchParams.get('archived') || '',
            daysToLeaseExpiry: searchParams.get('daysToLeaseExpiry') || '',
            searchText: searchParams.get('searchText') || ''
        };
    }

    updateUrlParams(params) {
        const searchParams = new URLSearchParams(this.props.location.search || "");
        Object.entries(params).forEach(([key, value]) => {
            if (value === null || value === undefined || value === '' || (Array.isArray(value) && value.length === 0)) {
                searchParams.delete(key);
            } else {
                const formatted = Array.isArray(value) ? value.join(',') : String(value);
                searchParams.set(key, formatted);
            }
        });
        const queryString = searchParams.toString();
        this.props.history.replace({ search: queryString ? `?${queryString}` : '' });
    }

    applyUrlParams(defaultPropertyId) {
        const params = this.getUrlParams();
        const parsedMin = params.minBalance !== '' ? parseFloat(params.minBalance) : null;
        const parsedMax = params.maxBalance !== '' ? parseFloat(params.maxBalance) : null;
        const parsedDays = params.daysToLeaseExpiry !== '' ? parseInt(params.daysToLeaseExpiry, 10) : null;
        return {
            propertyId: params.propertyId || defaultPropertyId,
            minBalance: Number.isNaN(parsedMin) ? this.state.minBalance : (parsedMin ?? this.state.minBalance),
            maxBalance: Number.isNaN(parsedMax) ? this.state.maxBalance : (parsedMax ?? this.state.maxBalance),
            archived: params.archived === 'true' ? true : (params.archived === 'false' ? false : this.state.archived),
            daysToLeaseExpiry: Number.isNaN(parsedDays) ? this.state.daysToLeaseExpiry : (parsedDays ?? this.state.daysToLeaseExpiry),
            searchText: params.searchText || this.state.searchText
        };
    }

    async applyNotificationFilters(notificationFilters) {
        if (!notificationFilters) return;
        const signature = this.getNotificationFiltersSignature(notificationFilters);
        if (signature && signature === this.state.lastAppliedNotificationFiltersSignature) {
            return;
        }
        await this.setState({
            ...notificationFilters,
            offset: "",
            lastAppliedNotificationFiltersSignature: signature
        });
        await this.filterTenants();
    }

    async fetchInitialData () {
        this.setState({showLoading: true});
        await Promise.all([
            (
                async () => {
                    if (_.isEmpty(this.props.properties) || _.isEmpty(this.props.tenants)) {
                        await store.dispatch(fetchPropertiesUnitsTenants);
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.options)) {
                        await this.props.fetchOptions();
                    }
                }
            )(),
            (
                async () => {
                    if (_.isEmpty(this.props.currency)) {
                        await this.props.fetchCurrency();
                    }
                }
            )(),
            (
                async () => {
                let params = { propertyIds:[], archived: false, searchText: "",
                maxBalance: null, minBalance:null, daysToLeaseExpiry:0, offset:"", limit:50, sortOrder:"asc", sortField:"unitName"
                };
                if (_.isEmpty(this.props.tenants)) {
                    let action = await this.props.fetchTenants(params, false);
                    let tenantOffset = action.offset;
                    this.setState({offset: tenantOffset});
                }
            }
            )(),
        ]);
        this.setState({showLoading: false});
    }

    async componentDidMount(){
        await this.fetchInitialData();
        const hasAllInvoicePerm = PermChecker.checkUserHasPermission(PermChecker.INVOICE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllMsgPerm = PermChecker.checkUserHasPermission(PermChecker.MESSAGE_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllPaymentPerm = PermChecker.checkUserHasPermission(PermChecker.PAYMENT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const hasAllTenantPerm = PermChecker.checkUserHasPermission(PermChecker.TENANT_MODEL, PermChecker.ALL_PERM, this.props.options?.userPermissions);
        const notificationFilters = this.getNotificationFiltersFromLocation();
        const defaultPropertyId = Object.values(this.props.properties).length === 1 ? Object.values(this.props.properties)[0].propertyId : "";
        const urlState = this.applyUrlParams(defaultPropertyId);
        this.setState({
            properties: Object.values(this.props.properties),
            propertyId: urlState.propertyId,
            minBalance: urlState.minBalance,
            maxBalance: urlState.maxBalance,
            archived: urlState.archived,
            daysToLeaseExpiry: urlState.daysToLeaseExpiry,
            searchText: urlState.searchText,
            selectedTenants: this.getTenantsOrder(),
            userAllPerms: {
                invoice: hasAllInvoicePerm,
                message: hasAllMsgPerm,
                payment: hasAllPaymentPerm,
                tenant: hasAllTenantPerm
            },
            filtersReady: true
        }, async () => {
            if (notificationFilters) {
                await this.applyNotificationFilters(notificationFilters);
            } else {
                await this.filterTenants();
            }
        });
    }

    async componentDidUpdate(prevProps, prevState) {
        const notificationFilters = this.getNotificationFiltersFromLocation();
        const prevNotificationFilters = prevProps.location?.state?.notificationFilters || null;
        if (!this.state.filtersReady) {
            if (notificationFilters && notificationFilters !== prevNotificationFilters) {
                await this.applyNotificationFilters(notificationFilters);
            }
            if(this.props.tenants !== prevProps.tenants){
                this.setState({selectedTenants: this.getTenantsOrder()});
            }
            return;
        }
        if(this.state.propertyId !== prevState.propertyId || this.state.tenantToShift !== prevState.tenantToShift || this.state.tenant !== prevState.tenant){
                const params = this.getQueryParams();
                await this.props.showLoading(true);
                await this.fetchMoreTenants();
        }
        const filtersChanged = (
            this.state.propertyId !== prevState.propertyId ||
            this.state.minBalance !== prevState.minBalance ||
            this.state.maxBalance !== prevState.maxBalance ||
            this.state.archived !== prevState.archived ||
            this.state.daysToLeaseExpiry !== prevState.daysToLeaseExpiry ||
            this.state.searchText !== prevState.searchText
        );
        if (filtersChanged) {
            this.updateUrlParams({
                propertyId: this.state.propertyId,
                minBalance: this.state.minBalance,
                maxBalance: this.state.maxBalance,
                archived: this.state.archived ? 'true' : '',
                daysToLeaseExpiry: this.state.daysToLeaseExpiry,
                searchText: this.state.searchText
            });
        }
        if (notificationFilters && notificationFilters !== prevNotificationFilters) {
            await this.applyNotificationFilters(notificationFilters);
        }
        if(this.props.tenants !== prevProps.tenants){
            this.setState({selectedTenants: this.getTenantsOrder()});
        }
    }

    getTenantsOrder() {
        let order = this.props.tenantsOrder;
        let orderedRecords = [];
        for (let id of order) {
            if ((this.props.tenants).hasOwnProperty(id)) {
                orderedRecords.push(this.props.tenants[id]);
            }
        }
        return this.formatTenantData(orderedRecords);
    }

        formatTenantData(tenants){
        return tenants.map(
            tenant => ({
                tenantName: tenant,
                propertyName: this.props.properties[tenant.propertyId]? this.props.properties[tenant.propertyId].propertyName: "",
                unitName: this.props.units[tenant.unitId]? this.props.units[tenant.unitId].unitName: "",
                balance: tenant,
                ...tenant
            })
        )
    }

    getQueryParams() {
        const { minBalance, maxBalance, searchText, sortField, offset, sortOrder, daysToLeaseExpiry, propertyId } = this.state;
        let { archived } = this.state;
        if (typeof archived === "string") {
          if (archived === "false") {
            archived = false;
          } else if (archived === "true") {
            archived = true;
          } else {
            archived = false;
          }
        }

        return {
          propertyIds: propertyId ? [propertyId] : [],
          minBalance,
          maxBalance,
          archived: archived,
          daysToLeaseExpiry,
          offset,
          searchText,
          sortField,
          sortOrder,
          limit: 50
        };
    }

    async fetchMoreTenants( appendData = false ) {
        if (this.state.isLoadingMore) return;
        this.setState({ isLoadingMore: true });
        const params = this.getQueryParams();
        this.props.showLoading(true);
        let offset = this.state.offset;
        const action = (await this.props.fetchTenants(params, appendData));
        let selectedTenants = this.getTenantsOrder();
        offset = action.offset;
        this.setState({
            selectedTenants,
            offset,
            isLoadingMore: false
        });
    }

    handleChange(event){
        event.preventDefault();
        const target = event.target;
        let name = target.name;
        let val = target.type === 'checkbox' ? target.checked : target.value;
        this.setState({[name]: val, offset: ""});
        this.fetchTenantData({[name]: val});
    }

    openTenantAccount(tenantId, event){
        // event.preventDefault();
        let tenantDetails = this.props.tenants[tenantId];
        Mixpanel.track("Tenants tab: open tenant account");
        this.props.history.push({
            pathname: UNIFORM_RESOURCE_LOCATORS.tenantTransactions,
            state: {
                tenant: tenantDetails
            }
        });
    }

    async handleSelectTenant(tenant, event){
        event.preventDefault();
        await this.setState(() => ({
            tenant,
            tab: TENANT_FORM_PAGE
        }));
    }

    handleDeleteTenant(propertyId, unitId, tenantId, event) {
        event.preventDefault();

        if (window.confirm("Are you sure you want to delete this tenant?")) {
            this.props.showLoading(true);
            this.props.deleteTenant(propertyId, unitId, tenantId);
        }
    }

    async handleSelectTenantAction(key, value){
        if (key === 'edit'){
            let tenant = this.props.tenants[value];
            this.setState(() => ({
                tenant,
                tab: TENANT_FORM_PAGE
            }));
        }
        else if(key === 'archive' || key === 'unarchive'){
            let tenant = this.props.tenants[value];
            this.props.showLoading(true);
            let action = await this.props.updateTenant({
                ...tenant,
                archived: !tenant.archived
            });
            await this.showNotificationPromptIfEligible();
            if(!action.errors){
                // setting state to force component to update and switch from archived to unarchvied or vice versa
                let selectedTenants = this.getTenantsOrder();
                this.setState((prevState)=>({
                    selectedTenants
                }))
            }
        }
        else if(key === 'sendMessage'){
            let tenant = this.props.tenants[value];
            this.setState(() => ({
                tenant,
                tab: MESSAGE_FORM_PAGE
            }));
        }else if(key === 'sendPaymentReminder'){
            let tenantIds = [value];
            this.props.showLoading(true);
            await this.props.sendPaymentReminder({tenantIds})
            await this.showNotificationPromptIfEligible();
        }else if(key === 'sendTenantStatement'){
            let tenantIds = [value];
            this.props.showLoading(true);
            await this.props.sendTenantStatement({tenantIds});
            await this.showNotificationPromptIfEligible();
        }else if(key === 'downloadTenantTransactions'){
            let tenantId = value;
            this.props.showLoading(true);
            const outputFormat = "pdf";
            await this.props.downloadTenantTransactionsReport({tenantId, outputFormat});
            await this.showNotificationPromptIfEligible();
        }else if(key === 'downloadCSV'){
            let tenantId = value;
            this.props.showLoading(true);
            const outputFormat = "csv";
            await this.props.downloadTenantTransactionsReport({tenantId, outputFormat});
            await this.showNotificationPromptIfEligible();
        }else if(key === 'shiftTenant'){
            let tenantToShift = value;
            this.setState(() => ({
                tenantToShift,
                tab: SHIFT_TENANT_FORM_PAGE
            }));
        }else if (key === 'addInvoice'){
            let tenant = this.props.tenants[value];
            this.setState(() => ({
                tenant,
                tab: INVOICE_FORM_PAGE
            }));
        }else if (key === 'addPayment'){
            let tenant = this.props.tenants[value];
            this.setState(() => ({
                tenant,
                tab: PAYMENT_FORM_PAGE
            }));
        }
    }

    async filterTenants(){
        let params = this.getQueryParams();
        this.props.showLoading(true);
        let payloadResult = await this.props.fetchTenants(params);
        let offset = this.state.offset;
        if(payloadResult){
            offset = payloadResult.offset;
        }

        this.setState((state) => {
            const selectedTenants = this.getTenantsOrder();
            return {
                selectedTenants,
                offset
            }
        });
    }

    getDefaultPropertyId(){
        const properties = Object.values(this.props.properties || {});
        return properties.length === 1 ? properties[0].propertyId : "";
    }

    handleClearFilters(){
        this.setState({
            propertyId: this.getDefaultPropertyId(),
            archived: false,
            daysToLeaseExpiry: 0,
            minBalance: 0,
            maxBalance: 0
        });
    }

    renderActiveFilters(){
        const hasPropertyFilter = !!this.state.propertyId;
        const hasArchivedFilter = !!this.state.archived;
        const hasLeaseExpiry = !!this.state.daysToLeaseExpiry;
        const hasMinBalance = this.state.minBalance !== 0 && this.state.minBalance !== "";
        const hasMaxBalance = this.state.maxBalance !== 0 && this.state.maxBalance !== "";
        const hasBalanceFilter = hasMinBalance || hasMaxBalance;
        const hasFilters = hasPropertyFilter || hasArchivedFilter || hasLeaseExpiry || hasBalanceFilter;

        if (!hasFilters) return null;

        return (
            <div className="ion-padding-start ion-padding-end" style={{ marginBottom: '6px' }}>
                <div style={{ display: 'flex', gap: '8px', overflowX: 'auto' }}>
                    {hasPropertyFilter && (
                        <IonChip>
                            <IonLabel>Property</IonLabel>
                        </IonChip>
                    )}
                    {hasBalanceFilter && (
                        <IonChip>
                            <IonLabel>Balance</IonLabel>
                        </IonChip>
                    )}
                    {hasLeaseExpiry && (
                        <IonChip>
                            <IonLabel>Lease Expiry</IonLabel>
                        </IonChip>
                    )}
                    {hasArchivedFilter && (
                        <IonChip>
                            <IonLabel>Archived</IonLabel>
                        </IonChip>
                    )}
                    <IonChip onClick={this.handleClearFilters.bind(this)}>
                        <IonLabel>Clear All</IonLabel>
                    </IonChip>
                </div>
            </div>
        );
    }

    handleSelectProperty(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { propertyId, unitId, tenantId } = prevState;
            if (propertyId != value) {
                propertyId = value;
                unitId = "";
                tenantId = "";
            }
            return {
                propertyId, unitId, tenantId
            };
        });
    }

    handleSelectUnit(event) {
        event.preventDefault();
        let value = event.target.value;
        this.setState((prevState) => {
            let { unitId, tenantId } = prevState;
            if (unitId != value) {
                unitId = value;
                tenantId = "";
            }
            return {
                unitId,
                tenantId
            }
        });
    }

    async handleFilterModalDismiss(){
        this.setState({tab: HOME_PAGE});
        this.props.showLoading(true);
        await this.filterTenants();
    }

    renderFilters(){
        return (
            <IonModal isOpen={this.state.tab === PAGE_FILTERS} onDidDismiss={this.handleFilterModalDismiss}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Filters</IonTitle>
                        <IonButtons slot="end">
                            <IonButton
                                onClick={this.handleFilterModalDismiss}
                            >Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <div className='d-flex justify-content-center'>
                    <IonList style={{maxWidth: '350px'}}>
                    <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <IonSelect
                            label="Property"
                            labelPlacement="stacked"
                            interface="popover"
                            value={this.state.propertyId}
                            onIonChange={this.handleSelectProperty.bind(this)}
                        >
                            <IonCustomPropertySelect propertiesArray={this.state.properties}/>
                        </IonSelect>
                    </IonItem>
                    <div style={{ marginTop: '6px', marginBottom: '6px', width: '100%' }}>
                    <AmountFilter
                        minAmount={this.state.minBalance}
                        maxAmount={this.state.maxBalance}
                        handleChangeAmount={this.handleChangeAmount}
                        component={"tenants"}
                    />
                    </div>
                    <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <IonSelect
                            label="Days to Lease Expiry"
                            labelPlacement="stacked"
                            interface="popover"
                            value={this.state.daysToLeaseExpiry}
                            onIonChange={(e) => this.setState({ daysToLeaseExpiry: e.detail.value })}
                        >
                            <IonSelectOption value={0}>-</IonSelectOption>
                            {(this.props.options?.leaseExpiryReminderDays || []).map((day) => (
                                <IonSelectOption key={day} value={day}>{day} days</IonSelectOption>
                            ))}
                        </IonSelect>
                    </IonItem>
                    <IonItem style={{ marginTop: '6px', marginBottom: '6px' }}>
                        <IonCheckbox
                            name="archived"
                            id="archived"
                            labelPlacement="end"
                            checked={this.state.archived}
                            onIonChange={async (e) => {
                                this.setState({archived: e.detail.checked});
                            }}
                        >
                            Show Deleted {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"}
                        </IonCheckbox>
                    </IonItem>
                </IonList>
                </div>
                </IonContent>
            </IonModal>
        )
    }

    renderTenantsTable(){
        return(
            <React.Fragment>
                <IonHeader className='ion-no-border'>
                <Row className='mr-0'>
                    <Col className='mr-0 pr-0 mx-md-4' xs={10} md={10}>
                        <IonSearchbar
                            onIonInput={(e) => {
                                this.setState({ searchText: e.detail.value });
                            }}
                            onIonChange={async (e) => {
                                this.setState({ searchText: e.detail.value });
                                await this.filterTenants();
                            }}
                        />
                    </Col>
                    <Col className='mx-0 my-2 pt-1 rounded' xs={2} md={2} style={{width:'3.4375em', backgroundColor: colorTheme["primary"]["25"], color: colorTheme["primary"]["800"]}}>
                        <IonIcon onClick={ () => { this.setState({tab: PAGE_FILTERS}) }}
                            size="large" aria-hidden="true"
                            id='tenant-page-filter-icon'
                        icon={optionsOutline}
                        />
                    </Col>
                </Row>
                {this.renderActiveFilters()}
                    <Row className='border-bottom py-1'>
                        <Col className='ml-4' xs={7} md={6}>
                            <Row>
                                <Col xs={12} md={5}>
                                    <strong>{this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant Name" : "Member Name"}</strong>
                                </Col>
                                <Col xs={12} md={5} className='d-none  d-md-block'>
                                <strong>Unit Name | Property</strong>
                                </Col>
                            </Row>
                        </Col>

                        <Col xs={3} md={5} className='flex justify-content-end justify-content-md-start'>
                            <strong>Account Balance</strong>
                        </Col>
                    </Row>
                </IonHeader>

                <div>

                {/* <Card style={{margin: 0, padding: 0}}> */}
                <IonList id='ion-list-descriptions' style={{margin: 0, padding: 0}}>
                    {this.state.selectedTenants.map((tenant, index) => {
                        let tenantName = "";
                        let currency = "";
                        let unitName = "";
                        let propertyName = "";
                        let accountNumber = "";
                        let accountBalance = 0;
                        let phoneNumber = "";
                        if(tenant){
                            tenantName = tenant.firstName + " " + tenant.lastName;
                            accountBalance = tenant.accountBalance?.replace(/,/g, "") || 0;
                            accountNumber = tenant.accountId;
                            phoneNumber = tenant.phoneNumber;
                            currency = !_.isEmpty(this.props.currency)? this.props.currency.customerCurrency: "";
                            unitName = tenant.unitName;
                            propertyName = tenant.propertyName;
                        }
                        return (
                            <TenantListItem
                                index={index}
                                key={tenant.tenantId}
                                tenant = {tenant}
                                tenantId={tenant.tenantId}
                                tenantName={tenantName}
                                accountBalance={accountBalance}
                                unitName={unitName}
                                propertyName={propertyName}
                                currency={currency}
                                accountNumber={accountNumber}
                                phoneNumber={phoneNumber}
                                showDetails={false}
                                userAllPerms={this.state.userAllPerms}
                                options={this.props.options}
                                openTenantAccount={this.openTenantAccount.bind(this)}
                                // onClickAssignTenant={this.onClickAssignTenant.bind(this)}
                                handleTenantAction={this.handleSelectTenantAction.bind(this)}
                        />
                        )
                    })}
                    </IonList>

                    <IonInfiniteScroll
                        disabled={this.state.offset === ""}
                        threshold='100px'
                        onIonInfinite={async (ev) => {
                            if (this.state.isLoadingMore) {
                                ev.target.complete();
                                return;
                            }
                            this.setState({ isLoadingMore: true });
                            await this.fetchMoreTenants(true);
                            this.setState({ isLoadingMore: false }, () => {
                                ev.target.complete();
                            });
                        }}
                    >
                        <IonInfiniteScrollContent loadingText="Please wait..." loadingSpinner="bubbles"></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                    {this.state.offset !== "" && (
                        <IonButton expand="block" onClick={async () => await this.fetchMoreTenants(true)}>
                            Load More {OCCUPANT_TYPE === this.props.options.userAccountType ? "Tenants" : "Members"}
                        </IonButton>
                    )}
                {/* </Card> */}
                </div>
            </React.Fragment>
        )
    }

    renderHomePage = () => {
        return(
            <div>
                {this.renderTenantsTable()}
            </div>
        )
    }

    handleCloseTenantForm(){
        this.setState({tab: HOME_PAGE, tenant: [], tenantToShift: ""});
    }

    handleClosePaymentForm(){
        this.setState({tab: HOME_PAGE, paymentId: "", tenantDetails: null, tenant: [] });
    }

    handleCloseInvoiceForm(){
        this.setState({tab: HOME_PAGE, invoiceId: "", tenantDetails: null, tenant: [] });
    }

    renderTenantForm(){
        return (
            <IonModal isOpen={this.state.tab === TENANT_FORM_PAGE} onDidDismiss={this.handleCloseTenantForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>{this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant Form" : "Member Form"}</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseTenantForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <TenantForm
                        tenantDetails={this.state.tenant}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderPaymentForm(){
        return (
            <IonModal isOpen={this.state.tab === PAYMENT_FORM_PAGE} onDidDismiss={this.handleClosePaymentForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Payment Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleClosePaymentForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <PaymentForm
                        tenantDetails={this.state.tenant}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderInvoiceForm(){
        return (
            <IonModal isOpen={this.state.tab === INVOICE_FORM_PAGE} onDidDismiss={this.handleCloseInvoiceForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Invoice Form</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseInvoiceForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <InvoiceForm
                        tenantDetails={this.state.tenant}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderShiftTenantForm(){
        return (
            <IonModal isOpen={this.state.tab === SHIFT_TENANT_FORM_PAGE} onDidDismiss={this.handleCloseTenantForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Shift {this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseTenantForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <ShiftTenantForm
                        tenantId={this.state.tenantToShift}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderMessageForm(){
        return (
            <IonModal isOpen={this.state.tab === MESSAGE_FORM_PAGE} onDidDismiss={this.handleCloseTenantForm}>
                <IonHeader>
                    <IonToolbar>
                        <IonTitle>Send Message</IonTitle>
                        <IonButtons slot="end">
                            <IonButton onClick={this.handleCloseTenantForm}>Close</IonButton>
                        </IonButtons>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    <SendMessageForm
                        tenant={this.state.tenant}
                    />
                </IonContent>
            </IonModal>

        );
    }

    renderTenantBalancePage(){
        return (
            <TenantTransactions tenant={this.state.tenant} tenantCurrentPage={this.state.currentPage} />
        );
    }

    async showNotificationPromptIfEligible() {
        await openNotificationPromptIfEligible((open) => this.setState({ showNotificationPrompt: open }));
    }

    render(){
        return(
            <IonPage>
                <NotificationPermissionModal
                    isOpen={this.state.showNotificationPrompt}
                    header="Enable notifications?"
                    message={`Get alerts for ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"} with balances and send timely payment reminders.`}
                    onCancel={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'tenants');
                    }}
                    onAllow={async () => {
                        await handleNotificationPromptAllow((open) => this.setState({ showNotificationPrompt: open }), 'tenants');
                    }}
                    onDeny={async () => {
                        await handleNotificationPromptDeny((open) => this.setState({ showNotificationPrompt: open }), 'tenants');
                    }}
                />
                <IonHeader>
                    <IonToolbar>
                        <IonButtons slot="start">
                            <IonMenuButton />
                        </IonButtons>
                        <IonTitle>{this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenants" : "Members"}</IonTitle>
                    </IonToolbar>
                </IonHeader>

            <IonContent>
                <IonLoading className="custom-loading" isOpen={this.state.showLoading} message="Loading ..." />
                {(this.state.tab == PAGE_FILTERS) && this.renderFilters()}

                {(this.state.tab == HOME_PAGE) && this.renderHomePage()}

                {(this.state.tab == TENANT_FORM_PAGE) && this.renderTenantForm()}

                {this.state.tab ==  INVOICE_FORM_PAGE && this.renderInvoiceForm()}

                {this.state.tab ==  PAYMENT_FORM_PAGE && this.renderPaymentForm()}

                {(this.state.tab == MESSAGE_FORM_PAGE) && this.renderMessageForm()}

                {/* {(this.state.tab == PAGE_PROPERTY_RENT_INVOICE_FORM) &&(<PropertyInvoicesForm/>)}
                {(this.state.tab == PAGE_RECURRING_BILLS_INVOICE_FORM) && (<RecurringBillsInvoicesForm/>)} */}

                {(this.state.tab == SHIFT_TENANT_FORM_PAGE) && this.renderShiftTenantForm()}

                {(this.state.tab == TENANT_ACCOUNT) && this.renderTenantBalancePage()}

                <IonFab id='ion-fab-button' className='ion-fab' slot="fixed" vertical="bottom" horizontal="end">
                    <IonFabButton aria-label="Actions">
                        <IonIcon icon={add} />
                    </IonFabButton>
                    <IonFabList side="top">
                        {this.state.userAllPerms.tenant &&
                        <IonFabButton
                            id='tenant-page-form-ion-fab-icon'
                            onClick={() => this.setState({tab: TENANT_FORM_PAGE, tenant: null })}
                            data-desc={`Add New ${this.props.options.userAccountType === OCCUPANT_TYPE ? "Tenant" : "Member"}`}
                        >
                            <IonIcon icon={personOutline}></IonIcon>
                        </IonFabButton>
                        }

                        {this.state.userAllPerms.payment &&
                        <IonFabButton
                            onClick={() => this.setState({tab: PAYMENT_FORM_PAGE, tenant: null })}
                            id='payment-page-form-ion-fab-icon'
                            data-desc="Add New Payment"
                        >
                            <IonIcon icon={cash}></IonIcon>
                        </IonFabButton>
                        }
                        {this.state.userAllPerms.invoice &&

                        <IonFabButton
                            onClick={() => this.setState({tab: INVOICE_FORM_PAGE, tenant: null })}
                            id='invoice-page-form-ion-fab-icon'
                            data-desc="Add New Invoice"
                        >
                            <IonIcon icon={receipt}></IonIcon>
                        </IonFabButton>
                        }
                    </IonFabList>
                </IonFab>
            </IonContent>

            </IonPage>
        )
    }
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Tenants));
